import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { statisticsPeriodOptions } from './statistics'
import type { DouyinStatisticsPeriod, DouyinStatisticsWindow } from './douyinStatisticsWindow'
export { douyinStatisticsSearch, douyinStatisticsWindow } from './douyinStatisticsWindow'
export type { DouyinStatisticsPeriod, DouyinStatisticsWindow } from './douyinStatisticsWindow'

export const douyinStatisticsPeriodOptions: Array<{ key: DouyinStatisticsPeriod, label: string }> = [
  ...statisticsPeriodOptions,
  { key: 'all', label: '全部' },
]
const supportedPeriods = new Set<DouyinStatisticsPeriod>(douyinStatisticsPeriodOptions.map((item) => item.key))

export function useDouyinStatisticsPeriod(defaultPeriod: DouyinStatisticsPeriod = 'day') {
  const [searchParams, setSearchParams] = useSearchParams()
  const requested = searchParams.get('period') as DouyinStatisticsPeriod | null
  const period = requested && supportedPeriods.has(requested) ? requested : defaultPeriod
  const setPeriod = useCallback((value: DouyinStatisticsPeriod) => {
    setSearchParams((current) => {
      const next = new URLSearchParams(current)
      next.set('period', value)
      return next
    }, { replace: true })
  }, [setSearchParams])
  return [period, setPeriod] as const
}

export function DouyinStatisticsBar({
  period,
  onChange,
  window,
  title = '统计时间范围',
  ariaLabel = '抖音直播统计范围',
}: {
  period: DouyinStatisticsPeriod
  onChange: (value: DouyinStatisticsPeriod) => void
  window: DouyinStatisticsWindow | null
  title?: string
  ariaLabel?: string
}) {
  const detail = window
    ? `${window.label} · ${window.startDate} ~ ${window.endDate}`
    : '直播数据加载中'
  return <div className="pdd-statistics-bar dy-statistics-bar">
    <div><strong>{title}</strong><small>{detail}</small></div>
    <div className="metric-switch" role="group" aria-label={ariaLabel}>
      {douyinStatisticsPeriodOptions.map((item) => <button
        type="button"
        key={item.key}
        className={item.key === period ? 'is-active' : ''}
        aria-pressed={item.key === period}
        onClick={() => onChange(item.key)}
      >{item.label}</button>)}
    </div>
  </div>
}
